import {getErrorMessage} from '@Utils/error.util';

/**
 * Logs an email-maker error to both the browser console (immediate visibility for dev/QA) and the
 * server breadcrumb. The error is folded into the server message string because `window.PMW.log`
 * only transmits its first argument.
 */
export function logEmailMakerError(context: string, error: unknown): void {
  console.error(`[EmailMaker] ${context}`, error);
  window.PMW.log(`[EmailMaker] ${context}: ${getErrorMessage(error)}`);
}
